export default function AvatarIcon({ identity, color, size = 73 }: { identity: string; color: string; size?: number }) {
  const fontSize = Math.round(size * 0.33); // Scale font size proportionally
  const radius = (size / 73) * 33.5; // Scale radius proportionally
  const center = size / 2;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <g fill="none" fillRule="evenodd">
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill={color === 'grey' ? 'var(--sib-color_surface-grey-background)' : 'var(--brand-aqua-teal-200)'}
        />
        <text
          x="50%"
          y="50%"
          fontSize={fontSize}
          fontWeight="600"
          textAnchor="middle"
          alignmentBaseline="middle"
          strokeWidth="3px"
          fill={color === 'grey' ? 'var(--sib-color_content-primary)' : 'var(--brand-aqua-teal-800)'}
        >
          {identity}
        </text>
      </g>
    </svg>
  );
}
